import React, { useEffect, useState } from 'react';
import ShipmentList from '../components/shipment/ShipmentList';
import BookingForm from '../components/booking/BookingForm';
import { useLocation } from 'react-router-dom';
import BookingList from '@/components/booking/BookingList';

const Shipment = () => {
    const [view, setView] = useState('list');
    const [selectedShipment, setSelectedShipment] = useState(null);

    const location = useLocation();

    const handleCreateNew = () => {
        window.open(
            `${window.location.origin}/booking/new`,
            "_blank",
            "noopener,noreferrer",
        );
    };

    const openBookingInNewTab = (shipmentOrId) => {
        const id =
            typeof shipmentOrId === "object"
                ? shipmentOrId?.id ?? shipmentOrId?.BookingId
                : shipmentOrId;
        if (!id) return;
        window.open(
            `${window.location.origin}/booking/edit/${id}`,
            "_blank",
            "noopener,noreferrer",
        );
    };

    const handleViewShipment = (shipmentOrId) => {
        openBookingInNewTab(shipmentOrId);
    };

    const handleBackToList = () => {
        setSelectedShipment(null);
        setView('list');
    };

    const bookingId = location?.state?.bookingId;

    useEffect(() => {
        if (bookingId) {
            setSelectedShipment(bookingId);
            setView('form');
        }
    }, [bookingId]);


    return (
        <div className="h-full p-4">
            {view === 'list' ? (
                <BookingList
                    onCreateNew={handleCreateNew}
                    onViewShipment={handleViewShipment}

                />
                
                
            ) : (
                <BookingForm
                    onBack={handleBackToList}
                    bookingData={selectedShipment}
                />
            )}
        </div>
    );
};

export default Shipment;
